/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenExportsCtrlNew", [
		"$scope", "toastr", "Utils", "$uibModal", "ExploitationService", "OpenExportsService", "$location", "AdminClientsService", "ExploitTimetablesService","FlexService", "type", "$window", "ENV",
		function ($scope, toastr, Utils, $uibModal, ExploitationService, OpenExportsService, $location, AdminClientsService, ExploitTimetablesService, FlexService, type, $window, ENV) {

		$scope.loading = false;
		$scope.utilsService = Utils;
		$scope.activeTab = [];
		$scope.status = {
			isNetworkAccordionOpen: []
		}

		$scope.data = {
			exportTemplate: {
				exportAllLines: false,
				attributionsExport : "NONE",
				idFormat: "SOURCE",
				hasFlexData: true,
				lines: []
			},
			networks: {},
			selectedNetwork: {},
			networkLines: {},
			lines: [],
			fetchMobiitiData: true,
			countDisplayCheckBoxAllLines: false,
			countDisplayCheckBoxAllLinesByNetwork: [],
			exportGeneratedMissingQuays: false,
			exportExternalIds: false,
		};
		var endDate;

		ExploitTimetablesService.getProductionPeriods().then((response) => {
			const data = response.data;
			if (data) {
				const maxMillis = Math.max(...data);
				const maxDate = new Date(maxMillis);
				endDate = maxDate;
			}
		});


		function populateDates() {
			if ($scope.data.exportTemplate.startdate === null || $scope.data.exportTemplate.startdate === undefined) {
				$scope.data.exportTemplate.startdate = new Date();
			}

			if ($scope.data.exportTemplate.enddate === null || $scope.data.exportTemplate.enddate === undefined) {
				$scope.data.exportTemplate.enddate = endDate;
			}
		}

		$scope.openServiceJourneyInformationsModal = function() {
			Utils.openModal($uibModal, "serviceJourneyInformations.html", $scope);
		};

		$scope.isGtfs = function() {
			return true;
		}
		$scope.isGtfsGlobal = function () {
			return false;
		}

		ExploitTimetablesService.getProductionPeriods().then((response) => {
			const data = response.data;
			if (data) {
				const maxMillis = Math.max(...data);
				const maxDate = new Date(maxMillis);
				endDate = maxDate;
			}
		});

		if ($window._env_.IS_FLEX_ACTIVATED === "true"){
				AdminClientsService.getCurrentClient().then((client) => {
					FlexService.hasData(client.code.toUpperCase()).then((response) => {
						$scope.data.hasFlexData = response.data.hasData;
					});
				});
		}

		ExploitationService.getNetworkWithLines($scope.data.fetchMobiitiData).then((response) => {
			$scope.data.networkLines = response.data;
			if ($scope.data.networkLines && $scope.data.networkLines.length > 0) {
				$scope.data.networkLines.forEach(network => {
					$scope.data.countDisplayCheckBoxAllLinesByNetwork[network.id] = false;
					$scope.status.isNetworkAccordionOpen[network.id] = false;
					network.lines.forEach(line => {
						$scope.data.exportTemplate.lines[line.id] = false;
					})
				})
			}
		});

		function selectTab(type) {
			$scope.activeTab[type] = true;
		}

		selectTab(type);

		$scope.clickTab = function (type) {
			$scope.activeTab[type] = true;
			$scope.data.exportTemplate = {}
		};

		// Gestion Date Start Picker
		$scope.openDateStart = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.datadatestart.dateOpened = true;
		};

		$scope.datadatestart = {
			dateFormat: "dd/MM/yyyy",
			date: new Date(),
			maxDate: new Date(),
			format: "longDate",
			dateOptions: {
				startingDay: 1
			},
			counterTypesSelected: {},
			state: {
				editing: false,
				isOneGroupSelected: false,
				areSeveralGroupsSelected: false
			},
			selected: []
		};

		// Gestion Date Fin Picker
		$scope.openDateEnd = function ($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.datadateend.dateOpened = true;
		};

		$scope.datadateend = {
			dateFormat: "dd/MM/yyyy",
			date: new Date(),
			maxDate: new Date(),
			format: "longDate",
			dateOptions: {
				startingDay: 1
			},
			counterTypesSelected: {},
			state: {
				editing: false,
				isOneGroupSelected: false,
				areSeveralGroupsSelected: false
			},
		};

		$scope.validateFilename = function() {
			const regex = /^[a-zA-Z0-9_-]+\.zip$/;
			const filename = $scope.data.exportTemplate.exportedFileName;
			if (!filename) {
				$scope.editForm.exportedFileName.$setValidity("customPattern", true);
				return;
			}

			const isValid = regex.test(filename);
			$scope.editForm.exportedFileName.$setValidity("customPattern", isValid);
		};

		// Changement d'état de la ligne pour la prendre en compte dans l'exportation
		$scope.addLineToExport = function (line, checked) {
			$scope.data.exportTemplate.lines[line.id] = checked;
			$scope.data.lines[line.id] = checked;
		};


		// Ajouter une ligne à exporter
		$scope.addOneLineToExport = function (line) {
			$scope.addLineToExport(line, !$scope.data.exportTemplate.lines[line.id]);
			checkAllLinesChecked();
		};

		// Ajouter toutes les lignes à exporter
		$scope.addAllLinesToExport = function () {
			$scope.data.networkLines.forEach(network => {
				network.lines.forEach(line => {
					$scope.addLineToExport(line, !$scope.data.countDisplayCheckBoxAllLines);
				})
			})
			checkAllLinesChecked();
		};

		// Ajouter toutes les lignes d'un réseau à exporter
		$scope.addAllLinesToExportByNetwork = function (networkId) {
			$scope.data.networkLines.forEach(network => {
				if (network.id === networkId) {
					network.lines.forEach(line => {
						$scope.addLineToExport(line, !$scope.data.countDisplayCheckBoxAllLinesByNetwork[networkId]);
					})
				}
			})
			checkAllLinesChecked();
		};

		$scope.isLinesEmpty = function() {
			return $scope.data.exportTemplate.lines.filter(b => b).length == 0;
		}

		function checkAllLinesChecked() {
			$scope.data.countDisplayCheckBoxAllLines = true;
			$scope.data.networkLines.forEach(network => {
				$scope.data.countDisplayCheckBoxAllLinesByNetwork[network.id] = true;
				checkAllLinesByNetworkChecked(network.lines);
			})
		}

		function checkAllLinesByNetworkChecked(lines) {
			lines.forEach(line => {
				if (!$scope.data.exportTemplate.lines[line.id]) {
					$scope.data.countDisplayCheckBoxAllLinesByNetwork[line.network] = false;
					$scope.data.countDisplayCheckBoxAllLines = false;
				}
			})
			return $scope.data.countDisplayCheckBoxAllLines;
		}

		$scope.getDefaultIDFormat = function () {
			if ($scope.data.exportTemplate.idFormat !== null && $scope.data.exportTemplate.idFormat !== undefined) {
				return $scope.data.exportTemplate.idFormat;
			}
			return 'SOURCE';
		};

		$scope.exportGtfs = function () {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminClientsService.getParentReferentialId(referential.id).then((parentRefId)  =>{
					// Erreur en cas de données vides
					if (!$scope.isEmpty($scope.data.exportTemplate.lines)) {
						populateDates();
						$scope.data.exportTemplate.ids = Utils.convertIndexTabToStringWithComma($scope.data.exportTemplate.lines);
						$scope.data.exportTemplate.referencetype = $scope.data.exportTemplate.lines == $scope.data.lines ? "" : "line";
						$scope.data.exportTemplate.attributionsExport = $scope.data.attributionsExport;
						OpenExportsService.exportGtfs(parentRefId, referential.user, $scope.data.exportTemplate)
							.then(() => {
								toastr.success("", "Export démarré");
								$location.path("/data-management/exports");
							}).catch(function () {
							toastr.error("Problème lors de l'export");
						});
					} else {
						toastr.error("Problème de selection des données à exporter");
					}
				});
			});
		};


	}]);
